import { render, staticRenderFns } from "./APIUserSettingsPage.vue?vue&type=template&id=197f1214&scoped=true"
import script from "./APIUserSettingsPage.vue?vue&type=script&lang=ts"
export * from "./APIUserSettingsPage.vue?vue&type=script&lang=ts"
import style0 from "./APIUserSettingsPage.vue?vue&type=style&index=0&id=197f1214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197f1214",
  null
  
)

export default component.exports